import { useEffect, useState } from "react";
import { Routes, Route, useLocation, matchPath, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "react-query";

import { UserContext, DeadlineContext } from "./Contexts";
import { AuthService, ConfigService } from "./Services";
import { DateHelpers } from "./Helpers/Date/DateHelpers";
import { getDefaultUser } from "wup-module1-base";

import AxiosInstance from "./AxiosInstance";
import LoadingWrapper from "./Routes/LoadingWrapper";
import { MainLayout, LoginLayout } from "./Components";
import { RouteConstants } from "./Constants";
import "./App.css";

const appQueryClient = new QueryClient();

function App() {
  const title = "Bilans Kariery";
  const mergedRoutes = RouteConstants.LoginLayout.concat(
    RouteConstants.MainLayout
  );
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(getDefaultUser());
  const [deadlines, setDeadlines] = useState({});

  useEffect(() => {
    if (!user.id) {
      getUserData();
    }
  }, []);

  useEffect(() => {
    if (user) {
      ConfigService.getDeadlinesFormattedToContext(user).then((response) => setDeadlines(response));
    }
  }, [user]);

  useEffect(() => {
    const route = mergedRoutes.find((route) =>
      matchPath({ path: route.path }, location.pathname)
    );
    document.title = route ? `${title} - ${route.titlePart}` : `${title}`;
  }, [location]);

  const getUserData = () => {
    AuthService.getUserData()
      .then((response) => {
        setUser({
          id: response.data.id,
          firstName: response.data.name,
          lastName: response.data.sureName,
          currentStep: response.data.status,
          isFirstRecrutation: DateHelpers.checkIsFirstRecruitmentMember(
            response.data.recruitingStageNumber
          ),
          permissions: [],
          roles: [],
          hasSpecialContract: response.data.hasSpecialContract,
          contractRecruitmentTypes: response.data.contractRecruitmentTypes,
          registerDate: response.data.registerDate,
          clientStep: response.data.clientStep,
          recruitmentType: response.data.recruitmentType,
          fromReserveList: response.data.fromReserveList,
          consentToVouchers: response.data.consentToVouchers,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <div>
      <QueryClientProvider client={appQueryClient}>
        <UserContext.Provider value={{ user, setUser, isLoading, setIsLoading }}>
          <DeadlineContext.Provider value={{ deadlines, setDeadlines }}>
            <Routes>
              <Route
                element={
                  <LoadingWrapper>
                    <LoginLayout />
                  </LoadingWrapper>
                }
              >
                {RouteConstants.LoginLayout.map((route) => {
                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.component}
                    />
                  );
                })}
              </Route>
              <Route
                element={
                  <LoadingWrapper>
                    <MainLayout />
                  </LoadingWrapper>
                }
              >
                {RouteConstants.MainLayout.map((route) => {
                  return (
                    <Route
                      key={route.path}
                      path={route.path}
                      element={route.component}
                    />
                  );
                })}
                <Route key={"notFound"} path={"*"} element={<Navigate to="/" />} />
              </Route>
            </Routes>
            <AxiosInstance />
          </DeadlineContext.Provider>
        </UserContext.Provider>
        <ToastContainer theme="colored" />
      </QueryClientProvider>
    </div>
  );
}

export default App;
